import styled from 'styled-components'
import { fromDesktop, belowDesktop, darkMode } from 'utilities/styled'
import { linkCss } from 'components/typography/link'
import { Grid } from 'components/grid'

export const AboutContainer = styled.div`
    display: flex;
    flex-direction: column;
    grid-area: about-feedback;
    row-gap: 24px;

    strong {
        font-weight: 500;
    }

    a {
        ${linkCss}
    }

    &:not(:has(img.dark)) {
        img {
            display: block !important;
        }
    }

    ${belowDesktop`
        display: contents;

        grid-template-columns: auto;
        grid-gap: 24px;
    `}
`

export const Summary = styled(Grid)`
    grid-area: summary;

    ${belowDesktop`
        order: 3;
    `}

    ${fromDesktop`
        grid-template-rows: 32px minmax(0, max-content);
        grid-auto-flow: row;
        grid-gap: 16px;
        align-items: center;
    `}
`

export const Picture = styled.picture`
    ${belowDesktop`
        &.from-desktop {
            display: none !important;
        }
    `}

    ${fromDesktop`
        &.below-desktop {
            display: none !important;
        }
    `}
`

export const Logo = styled.img`
    display: block;

    max-width: 120px;
    max-height: 32px;

    &.dark {
        display: none;
    }

    ${darkMode`
        display: none;

        &.dark {
            display: block;
        }
    `}

    ${belowDesktop`
        max-width: 150px;
        max-height: 40px;
    `}
`